"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _common = require("b2b-components/theme/components/CMS/common");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./ContactInfo.scss");
var ContactInfo = function ContactInfo(_ref) {
  var bottomHtmlText = _ref.bottomHtmlText,
    className = _ref.className,
    email = _ref.email,
    imageUrl = _ref.imageUrl,
    jobTitle = _ref.jobTitle,
    name = _ref.name,
    phone = _ref.phone,
    topHtmlText = _ref.topHtmlText,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _common.CMS_SIZING.size100 : _ref$size;
  if (!(bottomHtmlText || email || imageUrl || jobTitle || name || phone || topHtmlText)) {
    return null;
  }
  var rootClassName = (0, _classnames["default"])('cds-cms-ContactInfo', "cds-cms-ContactInfo--".concat(size), className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, topHtmlText && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-cms-ContactInfo-RichText cds-cms-RichTextEditor",
    dangerouslySetInnerHTML: {
      __html: topHtmlText
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-cms-ContactInfo-ContactWrapper"
  }, imageUrl && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-cms-ContactInfo-ImageWrapper"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: name || '',
    className: "cds-cms-ContactInfo-Image",
    src: imageUrl
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-cms-ContactInfo-ContactDetailsWrapper"
  }, (name || jobTitle) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-cms-ContactInfo-NameWrapper"
  }, name && /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-cms-ContactInfo-Name"
  }, name), jobTitle && /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-cms-ContactInfo-JobTitle"
  }, jobTitle)), phone && /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-cms-ContactInfo-IconWithText"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-cms-ContactInfo-Icon",
    name: _Icon.ICON_NAME.phone
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-cms-ContactInfo-PhoneNumber"
  }, phone)), email && /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-cms-ContactInfo-IconWithText"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-cms-ContactInfo-Icon",
    name: _Icon.ICON_NAME.mail
  }), /*#__PURE__*/_react["default"].createElement("a", {
    className: "cds-cms-ContactInfo-Email",
    href: "mailto:".concat(email)
  }, email)))), bottomHtmlText && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-cms-ContactInfo-RichText cds-cms-RichTextEditor",
    dangerouslySetInnerHTML: {
      __html: bottomHtmlText
    }
  })));
};
exports.ContactInfo = ContactInfo;